__turbopack_context__.v({
  "arrow-flex": "CQ6j4G_arrow-flex",
  "center-wrap": "CQ6j4G_center-wrap",
  "contents-container": "CQ6j4G_contents-container",
  "header-container": "CQ6j4G_header-container",
  "header-wrap": "CQ6j4G_header-wrap",
  "left-wrap": "CQ6j4G_left-wrap",
  "reverse-arrow-link": "CQ6j4G_reverse-arrow-link",
  "right-wrap": "CQ6j4G_right-wrap",
  "simple-flex": "CQ6j4G_simple-flex",
});
